import SeoHead from '../../components/SeoHead';
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk"
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import ConsultantDetails from '../../components/ConsultantDetails';
import Header from '../../components/MainHeader';

export default function ConsultantPage({
    global,
    consultant,
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`${consultant.name} | Gap Personnel`}
                // description={`Meet the team at Driving Force. We are all passionate about what we do and our aim is to deliver a service that gives you the results you need.`}
                canonical_link={`/meet-the-team/${consultant.url_slug}/`}
            />
            <Header />
            <SubBanner
                global={global}
                pathPrefix={`consultant_page.sub_banner`}
                customClass={`mb-5 primary-banner`}
                buttonTitle={`Employers  /  Meet the team`}
                buttonLink={`/meet-the-team/`}
                consultantPage={true}
                heading={`${consultant.name}`}
                post={consultant}
            />
            <ConsultantDetails
                global={global}
                pathPrefix={`consultant_page.consultant_details`}
                consultant={consultant}
                customClass={`pb-5`}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const consultant = (await Collection('consultants')).getJsonItem(params.url_slug, 'url_slug');

    return {
        props: {
            global,
            consultant,
        },
    }
}

export async function getStaticPaths() {
    const pagePath = (await Collection('consultants')).getPaths('url_slug');
    return {
        paths: pagePath,
        fallback: false
    }
}